import React from 'react';
import { Form, Row, Col, InputGroup, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util/FormattedNumberInput';
import ClaimStateAlerts from '@rd-web-markets/shared/dist/claim/ClaimStateAlerts';
import { Link } from 'react-router-dom';
const QualifyingExpenditureSummaryPage = _ref => {
  let {
    accountType,
    claim
  } = _ref;
  const {
    t
  } = useTranslation();
  const renderRow = (label, fieldName) => {
    return /*#__PURE__*/React.createElement(Form.Group, {
      as: Row,
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(Form.Label, {
      column: true,
      md: 6
    }, t(label)), /*#__PURE__*/React.createElement(Col, {
      md: 6
    }, /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(InputGroup.Text, null, "\xA3"), /*#__PURE__*/React.createElement(FormattedNumberInput, {
      value: claim[fieldName] || 0,
      disabled: true,
      size: "md",
      type: "text"
    }))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClaimStateAlerts, {
    claim: claim
  }), /*#__PURE__*/React.createElement(Form, null, renderRow('staffing_costs', 'employee_qualifying_rnd_expenditure'), renderRow('subcontracting', 'subcontractor_qualifying_rnd_expenditure'), renderRow('external_workers', 'external_workers_rnd_amount_total'), renderRow('rnd_consumables', 'consumable_qualifying_rnd_expenditure'), renderRow('software', 'software_consumables_qualifying_rnd_expenditure'), renderRow('cloud_computing_costs', 'cloud_computings_qualifying_rnd_expenditure'), renderRow('data_licences_cost', 'data_licences_costs_qualifying_rnd_expenditure'), renderRow('independent_rnd_contribution', 'independent_rnd_contributions_qualifying_rnd_expenditure'), renderRow('payments_to_clinical_trial_subjects', 'payments_to_clinical_trials_qualifying_rnd_expenditure'), renderRow('amount_qualifying_indirect_activities', 'qualifying_indirect_activities_expenditure'), /*#__PURE__*/React.createElement("hr", {
    className: "my-4"
  })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-start"
  }), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-end"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "primary",
    to: "/".concat(accountType, "/claims/").concat(claim.id, "/financial_details/general")
  }, "Continue ", /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_right")))));
};
export default QualifyingExpenditureSummaryPage;